import {NEXT_NAVIGATION_STEP_ONE,NEXT_NAVIGATION_STEP_TWO,NEXT_NAVIGATION_STEP_TREE,NEXT_NAVIGATION_STEP_FOUR} from '../actions/types';

const INITIAL_STATE = {
    Line:0,
};

export default (state=INITIAL_STATE ,action)=>{
    switch(action.type) {
        case NEXT_NAVIGATION_STEP_ONE:
            return {
                Line:0
            }
        case NEXT_NAVIGATION_STEP_TWO:
            return {
                Line:25+'%'
            }
        case NEXT_NAVIGATION_STEP_TREE:
            return {
                Line:50+'%'
            }
        case NEXT_NAVIGATION_STEP_FOUR:
            return {
                Line:75+'%'
            }
        default:
            return state
    }
}





